// Mirrors Initiator/Models/EnemyResponse.cs: one standee inside a monster group.
interface Enemy {
    id: string;
    number: string | null;
    name: string | null;
    hitPoints: number | null;
    maxHitPoints: number | null;
    conditions: Condition[];
}
